import { ContainerModule } from '@evertel/di'
import { Analytics } from './Analytics'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(Analytics).toSelf().inSingletonScope()
    })
]

export {
    DI_MODULES
}
